__turbopack_context__.v({
  "contactButton": "PhotographerHeader-module__b-4qFa__contactButton",
  "contactButtonWrapper": "PhotographerHeader-module__b-4qFa__contactButtonWrapper",
  "photographerHeader": "PhotographerHeader-module__b-4qFa__photographerHeader",
  "photographerLocation": "PhotographerHeader-module__b-4qFa__photographerLocation",
  "photographerName": "PhotographerHeader-module__b-4qFa__photographerName",
  "photographerPortrait": "PhotographerHeader-module__b-4qFa__photographerPortrait",
  "photographerPresentation": "PhotographerHeader-module__b-4qFa__photographerPresentation",
  "photographerTagline": "PhotographerHeader-module__b-4qFa__photographerTagline",
  "portraitWrapper": "PhotographerHeader-module__b-4qFa__portraitWrapper",
});
